<template>
    <div class="flex flex-wrap items-start justify-between gap-4">
        <div class="flex items-center gap-3">
            <div
                class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-indigo-600"
            >
                <CalendarDaysIcon class="h-6 w-6 text-white" />
            </div>
            <div>
                <h1 class="text-2xl font-bold tracking-tight text-gray-900">
                    {{ t("vue.kiosk_da_app_title") }}
                </h1>
                <p class="mt-0.5 text-sm text-gray-500">
                    {{ t("vue.kiosk_da_description") }}
                </p>
            </div>
        </div>
        <KioskDayPicker
            :date="date"
            route-name="kiosk.daily-activity.index"
            input-id="activity-date"
        />
    </div>
</template>

<script lang="ts" setup>
import { CalendarDaysIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import KioskDayPicker from "../../components/KioskDayPicker.vue";

const { t } = useTranslations();

defineProps<{
    date: string;
}>();
</script>
